/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EventOrganizationRead } from './EventOrganizationRead';
import {
    EventOrganizationReadFromJSON,
    EventOrganizationReadFromJSONTyped,
    EventOrganizationReadToJSON,
    EventOrganizationReadToJSONTyped,
} from './EventOrganizationRead';
import type { EventRead } from './EventRead';
import {
    EventReadFromJSON,
    EventReadFromJSONTyped,
    EventReadToJSON,
    EventReadToJSONTyped,
} from './EventRead';
import type { ClockState } from './ClockState';
import {
    ClockStateFromJSON,
    ClockStateFromJSONTyped,
    ClockStateToJSON,
    ClockStateToJSONTyped,
} from './ClockState';
import type { CompetitionProblemRead } from './CompetitionProblemRead';
import {
    CompetitionProblemReadFromJSON,
    CompetitionProblemReadFromJSONTyped,
    CompetitionProblemReadToJSON,
    CompetitionProblemReadToJSONTyped,
} from './CompetitionProblemRead';
import type { CompetitorRead } from './CompetitorRead';
import {
    CompetitorReadFromJSON,
    CompetitorReadFromJSONTyped,
    CompetitorReadToJSON,
    CompetitorReadToJSONTyped,
} from './CompetitorRead';

/**
 * The caller's view of one event: the event, their team, their clock and the problems.
 * 
 * `started_at` and `deadline` are the organization's clock in an organization event and the
 * window (`available_start`, `available_end`) in a user event, whose `organization` is null.
 * @export
 * @interface EventMeRead
 */
export interface EventMeRead {
    /**
     * 
     * @type {EventRead}
     * @memberof EventMeRead
     */
    event: EventRead;
    /**
     * 
     * @type {CompetitorRead}
     * @memberof EventMeRead
     */
    competitor: CompetitorRead;
    /**
     * 
     * @type {EventOrganizationRead}
     * @memberof EventMeRead
     */
    organization?: EventOrganizationRead | null;
    /**
     * 
     * @type {Date}
     * @memberof EventMeRead
     */
    started_at?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof EventMeRead
     */
    deadline?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof EventMeRead
     */
    seconds_remaining?: number | null;
    /**
     * 
     * @type {ClockState}
     * @memberof EventMeRead
     */
    clock_state: ClockState;
    /**
     * 
     * @type {Array<CompetitionProblemRead>}
     * @memberof EventMeRead
     */
    problems: Array<CompetitionProblemRead>;
}



/**
 * Check if a given object implements the EventMeRead interface.
 */
export function instanceOfEventMeRead(value: object): value is EventMeRead {
    if (!('event' in value) || value['event'] === undefined) return false;
    if (!('competitor' in value) || value['competitor'] === undefined) return false;
    if (!('clock_state' in value) || value['clock_state'] === undefined) return false;
    if (!('problems' in value) || value['problems'] === undefined) return false;
    return true;
}

export function EventMeReadFromJSON(json: any): EventMeRead {
    return EventMeReadFromJSONTyped(json, false);
}

export function EventMeReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventMeRead {
    if (json == null) {
        return json;
    }
    return {
        
        'event': EventReadFromJSON(json['event']),
        'competitor': CompetitorReadFromJSON(json['competitor']),
        'organization': json['organization'] == null ? undefined : EventOrganizationReadFromJSON(json['organization']),
        'started_at': json['started_at'] == null ? undefined : (new Date(json['started_at'])),
        'deadline': json['deadline'] == null ? undefined : (new Date(json['deadline'])),
        'seconds_remaining': json['seconds_remaining'] == null ? undefined : json['seconds_remaining'],
        'clock_state': ClockStateFromJSON(json['clock_state']),
        'problems': ((json['problems'] as Array<any>).map(CompetitionProblemReadFromJSON)),
    };
}

export function EventMeReadToJSON(json: any): EventMeRead {
    return EventMeReadToJSONTyped(json, false);
}

export function EventMeReadToJSONTyped(value?: EventMeRead | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'event': EventReadToJSON(value['event']),
        'competitor': CompetitorReadToJSON(value['competitor']),
        'organization': EventOrganizationReadToJSON(value['organization']),
        'started_at': value['started_at'] == null ? undefined : ((value['started_at'] as any).toISOString()),
        'deadline': value['deadline'] == null ? undefined : ((value['deadline'] as any).toISOString()),
        'seconds_remaining': value['seconds_remaining'],
        'clock_state': ClockStateToJSON(value['clock_state']),
        'problems': ((value['problems'] as Array<any>).map(CompetitionProblemReadToJSON)),
    };
}

